import { TThunkAction } from '../../types/redux';
import { FDealType, dealTypeFromJsonQuery } from '../../utils/category';
import { setPageTitle } from './setPageTitle';

export const changePageTitle = (): TThunkAction => {
  return (dispatch, getState) => {
    const {
      rentFlightRkData,
      showRentFlightRk,
      mainpage: {
        seoData: { h1 },
      },
      filters: { jsonQuery },
    } = getState();

    const dealType = dealTypeFromJsonQuery(jsonQuery);

    const pageTitle =
      !!rentFlightRkData && (showRentFlightRk || dealType === FDealType.RentLongterm) ? rentFlightRkData.title : h1;

    dispatch(setPageTitle(pageTitle));
  };
};
